import { FilesActionsTypes } from '../../actions/files/files.actions';
import { AppState } from 'src/app/app.state';
import { IResponseMessage } from 'src/app/shared/models/response-message/IResponseMessage';

export interface FilesState {
  uploadFileError: IResponseMessage;
}

const initialState: FilesState = {
  uploadFileError: null
};

export function filesReducer(
  state: FilesState = initialState,
  action: any
): FilesState {
    switch (action.type) {
      case FilesActionsTypes.UPLOAD_FILE_ERROR:
        return {
          ...state,
          uploadFileError: action.error
        };
      default:
        return state;
    }
}
export const getFilesState = (state: AppState) => {
  return state.files;
};

export const getuploadFileError = (state: FilesState) => {
  return state.uploadFileError;
};
